// pages/admin/ServiciosAdmin.jsx
import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import AdminLayout from '../../layouts/AdminLayout';
import { 
  Bus, Calendar, Clock, MapPin, DollarSign, 
  Plus, Edit, Trash2, X, Check,
  ChevronLeft, ChevronRight, Settings, DollarSign as MoneyIcon,
  GitBranch, Pencil, AlertTriangle,
  Play, Pause // ✅ NUEVOS
} from 'lucide-react';
import Modal from '../../components/Modal';
import ModalConfirm from '../../components/ModalConfirm';
import { showSuccess, showError, showLoading, dismissToast } from '../../utils/toast';

const API_URL = process.env.REACT_APP_API_URL;

const ciudades = [
  { id: 1, nombre: "Ciudad Bolívar", estado: "Bolívar" },
  { id: 2, nombre: "Puerto Ordaz", estado: "Bolívar" },
  { id: 3, nombre: "San Félix", estado: "Bolívar" },
  { id: 4, nombre: "Upata", estado: "Bolívar" },
  { id: 5, nombre: "Guasipati", estado: "Bolívar" },
  { id: 6, nombre: "El Callao", estado: "Bolívar" },
  { id: 7, nombre: "Tumeremo", estado: "Bolívar" },
  { id: 8, nombre: "Santa Elena de Uairén", estado: "Bolívar" },
  { id: 9, nombre: "Kavak", estado: "Bolívar" },
  { id: 10, nombre: "San Ignacio de Yuruaní", estado: "Bolívar" },
  { id: 11, nombre: "El Paují", estado: "Bolívar" },
  { id: 12, nombre: "Ciudad Guayana", estado: "Bolívar" },
  { id: 13, nombre: "Maturín", estado: "Monagas" },
  { id: 14, nombre: "El Tigre", estado: "Anzoátegui" },
  { id: 15, nombre: "San Tomé", estado: "Anzoátegui" },
  { id: 16, nombre: "Cantaura", estado: "Anzoátegui" },
  { id: 17, nombre: "Anaco", estado: "Anzoátegui" },
  { id: 18, nombre: "Barcelona", estado: "Anzoátegui" },
  { id: 19, nombre: "Puerto La Cruz", estado: "Anzoátegui" },
  { id: 20, nombre: "Lechería", estado: "Anzoátegui" },
  { id: 21, nombre: "Cumaná", estado: "Sucre" },
  { id: 22, nombre: "Carúpano", estado: "Sucre" },
  { id: 23, nombre: "Porlamar", estado: "Nueva Esparta" },
  { id: 24, nombre: "La Asunción", estado: "Nueva Esparta" },
  { id: 25, nombre: "Caracas", estado: "Distrito Capital" },
  { id: 26, nombre: "Maracay", estado: "Aragua" },
  { id: 27, nombre: "Valencia", estado: "Carabobo" },
  { id: 28, nombre: "Barquisimeto", estado: "Lara" },
  { id: 29, nombre: "Maracaibo", estado: "Zulia" },
  { id: 30, nombre: "Boa vista", estado: "Roraima" },
  { id: 31, nombre: "Manaos", estado: "Amazonas" }
];

const ServiciosAdmin = () => {
  const navigate = useNavigate();
  const [servicios, setServicios] = useState([]);
  const [loading, setLoading] = useState(true);
  const [selectedFecha, setSelectedFecha] = useState('');
  const [showCalendar, setShowCalendar] = useState(false);
  const [calendarDate, setCalendarDate] = useState(new Date());
  const [showModal, setShowModal] = useState(false);
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showMetodosModal, setShowMetodosModal] = useState(false);
  const [showDeleteTramoModal, setShowDeleteTramoModal] = useState(false);
  const [servicioToDelete, setServicioToDelete] = useState(null);
  const [tramoToDelete, setTramoToDelete] = useState(null);
  const [editingServicio, setEditingServicio] = useState(null);
  const [editingTramo, setEditingTramo] = useState(null);
  const [selectedServicio, setSelectedServicio] = useState(null);
  const [metodosDisponibles, setMetodosDisponibles] = useState([]);
  const [metodosSeleccionados, setMetodosSeleccionados] = useState([]);
  const [tramos, setTramos] = useState([]);
  
  // ✅ Estado para info de reservas asociadas
  const [deleteInfo, setDeleteInfo] = useState({ reservasCount: 0, loading: false });

  // ✅ NUEVOS: estados para pausar/activar servicio
  const [showToggleModal, setShowToggleModal] = useState(false);
  const [servicioToToggle, setServicioToToggle] = useState(null);
  
  const calendarRef = useRef(null);
  
  const [origenSugerencias, setOrigenSugerencias] = useState([]);
  const [destinoSugerencias, setDestinoSugerencias] = useState([]);
  const [showOrigenSugerencias, setShowOrigenSugerencias] = useState(false);
  const [showDestinoSugerencias, setShowDestinoSugerencias] = useState(false);
  
  const [formData, setFormData] = useState({
    origen: '',
    destino: '',
    fechaSalida: '',
    horaSalida: '',
    fechaLlegada: '',
    horaLlegada: '',
    duracion: '',
    precio: ''
  });

  const [tramoForm, setTramoForm] = useState({
    origen: '',
    destino: '',
    precio: '',
    fechaSalida: '',
    horaSalida: '',
    fechaLlegada: '',
    horaLlegada: '',
    duracion: ''
  });

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (calendarRef.current && !calendarRef.current.contains(event.target)) {
        setShowCalendar(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const getTodayDate = () => {
    const today = new Date();
    return today.toISOString().split('T')[0];
  };

  const calcularDuracionCompleta = (fechaSalida, horaSalida, fechaLlegada, horaLlegada) => {
    if (!fechaSalida || !horaSalida || !fechaLlegada || !horaLlegada) return '';
    
    const salida = new Date(`${fechaSalida}T${horaSalida}`);
    const llegada = new Date(`${fechaLlegada}T${horaLlegada}`);
    
    if (llegada < salida) {
      llegada.setDate(llegada.getDate() + 1);
    }
    
    const diffMs = llegada - salida;
    const diffHoras = Math.floor(diffMs / (1000 * 60 * 60));
    const diffMinutos = Math.floor((diffMs % (1000 * 60 * 60)) / (1000 * 60));
    
    if (diffHoras >= 24) {
      const dias = Math.floor(diffHoras / 24);
      const horasRestantes = diffHoras % 24;
      if (dias > 0 && horasRestantes > 0 && diffMinutos > 0) {
        return `${dias}d ${horasRestantes}h ${diffMinutos}m`;
      } else if (dias > 0 && horasRestantes > 0) {
        return `${dias}d ${horasRestantes}h`;
      } else if (dias > 0) {
        return `${dias}d`;
      }
    }
    
    if (diffHoras > 0 && diffMinutos > 0) return `${diffHoras}h ${diffMinutos}m`;
    if (diffHoras > 0) return `${diffHoras}h`;
    if (diffMinutos > 0) return `${diffMinutos}m`;
    return '0h';
  };

  useEffect(() => {
    if (servicios.length > 0 && selectedFecha === '') {
      setSelectedFecha(getTodayDate());
    }
  }, [servicios]);

  useEffect(() => {
    if (formData.fechaSalida && formData.horaSalida && formData.fechaLlegada && formData.horaLlegada) {
      const duracion = calcularDuracionCompleta(
        formData.fechaSalida,
        formData.horaSalida,
        formData.fechaLlegada,
        formData.horaLlegada
      );
      setFormData(prev => ({ ...prev, duracion }));
    }
  }, [formData.fechaSalida, formData.horaSalida, formData.fechaLlegada, formData.horaLlegada]);

  useEffect(() => {
    if (tramoForm.fechaSalida && tramoForm.horaSalida && tramoForm.fechaLlegada && tramoForm.horaLlegada) {
      const duracion = calcularDuracionCompleta(
        tramoForm.fechaSalida,
        tramoForm.horaSalida,
        tramoForm.fechaLlegada,
        tramoForm.horaLlegada
      );
      setTramoForm(prev => ({ ...prev, duracion }));
    }
  }, [tramoForm.fechaSalida, tramoForm.horaSalida, tramoForm.fechaLlegada, tramoForm.horaLlegada]);

  const getProximosDias = () => {
    const dias = [];
    const hoy = new Date();
    
    for (let i = 0; i < 7; i++) {
      const fecha = new Date();
      fecha.setDate(hoy.getDate() + i);
      const fechaStr = fecha.toISOString().split('T')[0];
      const tieneServicios = servicios.some(s => s.fecha && s.fecha.split('T')[0] === fechaStr);
      
      let label = '';
      if (i === 0) label = 'Hoy';
      else if (i === 1) label = 'Mañana';
      else {
        const options = { weekday: 'short', day: 'numeric' };
        label = fecha.toLocaleDateString('es-AR', options);
      }
      
      dias.push({
        fecha: fechaStr,
        label: label,
        tieneServicios: tieneServicios
      });
    }
    return dias;
  };

  const getFechasConServicios = () => {
    const fechasSet = new Set();
    servicios.forEach(s => {
      if (s.fecha) {
        fechasSet.add(s.fecha.split('T')[0]);
      }
    });
    return fechasSet;
  };

  const filtrarCiudades = (texto) => {
    if (!texto) return [];
    return ciudades
      .filter(ciudad => 
        ciudad.nombre.toLowerCase().includes(texto.toLowerCase()) ||
        ciudad.estado.toLowerCase().includes(texto.toLowerCase())
      )
      .slice(0, 8);
  };

  const handleOrigenChange = (e) => {
    const value = e.target.value;
    setFormData({...formData, origen: value});
    setOrigenSugerencias(filtrarCiudades(value));
    setShowOrigenSugerencias(value.length > 0);
  };

  const handleDestinoChange = (e) => {
    const value = e.target.value;
    setFormData({...formData, destino: value});
    setDestinoSugerencias(filtrarCiudades(value));
    setShowDestinoSugerencias(value.length > 0);
  };

  const seleccionarOrigen = (ciudad) => {
    setFormData({...formData, origen: ciudad.nombre});
    setShowOrigenSugerencias(false);
  };

  const seleccionarDestino = (ciudad) => {
    setFormData({...formData, destino: ciudad.nombre});
    setShowDestinoSugerencias(false);
  };

  // ============ CARGAR DATOS ============

  const cargarServicios = async () => {
    setLoading(true);
    try {
      const response = await fetch(`${API_URL}/admin/servicios`);
      if (!response.ok) throw new Error('Error al cargar servicios');
      const data = await response.json();
      setServicios(data);
    } catch (error) {
      console.error('Error:', error);
      showError('No se pudieron cargar los servicios');
    } finally {
      setLoading(false);
    }
  };

  const cargarMetodosDisponibles = async () => {
    try {
      const response = await fetch(`${API_URL}/metodospago/activos`);
      if (!response.ok) throw new Error('Error al cargar métodos');
      const data = await response.json();
      setMetodosDisponibles(data);
    } catch (error) {
      console.error('Error al cargar métodos:', error);
    }
  };

  const cargarMetodosAsignados = async (servicioId) => {
    try {
      const response = await fetch(`${API_URL}/admin/servicios/${servicioId}/metodos-pago`);
      if (!response.ok) throw new Error('Error al cargar métodos asignados');
      const data = await response.json();
      setMetodosSeleccionados(data.map(m => m.id));
    } catch (error) {
      console.error('Error al cargar métodos asignados:', error);
      setMetodosSeleccionados([]);
    }
  };

  const cargarTramos = async (servicioId) => {
    try {
      const response = await fetch(`${API_URL}/admin/servicios/${servicioId}/tramos`);
      if (!response.ok) throw new Error('Error al cargar tramos');
      const data = await response.json();
      setTramos(data);
    } catch (error) {
      console.error('Error al cargar tramos:', error);
      setTramos([]);
    }
  };

  useEffect(() => {
    cargarServicios();
    cargarMetodosDisponibles();
  }, []);

  // ============ SERVICIOS CRUD ============

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    const toastId = showLoading(editingServicio ? 'Actualizando servicio...' : 'Creando servicio...');
    
    try {
      const servicioData = {
        origen: formData.origen,
        destino: formData.destino,
        fechaSalida: formData.fechaSalida,
        fechaLlegada: formData.fechaLlegada,
        horaSalida: formData.horaSalida + ':00',
        horaLlegada: formData.horaLlegada + ':00',
        precio: parseFloat(formData.precio)
      };

      let response;
      let servicioId;
      if (editingServicio) {
        response = await fetch(`${API_URL}/admin/servicios/${editingServicio.id}`, {
          method: 'PUT',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ ...servicioData, id: editingServicio.id })
        });
        servicioId = editingServicio.id;
      } else {
        response = await fetch(`${API_URL}/admin/servicios`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(servicioData)
        });
        const result = await response.json();
        servicioId = result.id;
      }

      if (!response.ok) {
        const errorText = await response.text();
        console.error('Error del backend:', errorText);
        throw new Error(`Error ${response.status}: ${errorText}`);
      }
      
      if (metodosSeleccionados.length > 0 && servicioId) {
        await fetch(`${API_URL}/admin/servicios/${servicioId}/metodos-pago`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(metodosSeleccionados)
        });
      }
      
      if (tramos.length > 0 && servicioId) {
        if (editingServicio) {
          const tramosExistentesResponse = await fetch(`${API_URL}/admin/servicios/${servicioId}/tramos`);
          const tramosExistentes = await tramosExistentesResponse.json();
          
          for (const tramo of tramosExistentes) {
            await fetch(`${API_URL}/admin/tramos/${tramo.id}`, {
              method: 'DELETE'
            });
          }
        }
        
        for (const tramo of tramos) {
          const tramoResponse = await fetch(`${API_URL}/admin/servicios/${servicioId}/tramos`, {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              origen: tramo.origen,
              destino: tramo.destino,
              precio: parseFloat(tramo.precio),
              fechaSalida: tramo.fechaSalida,
              fechaLlegada: tramo.fechaLlegada,
              horaSalida: tramo.horaSalida + ':00',
              horaLlegada: tramo.horaLlegada + ':00'
            })
          });
          
          if (!tramoResponse.ok) {
            const errorText = await tramoResponse.text();
            console.error('Error al crear tramo:', errorText);
          }
        }
      }
      
      await cargarServicios();
      setShowModal(false);
      resetForm();
      
      dismissToast(toastId);
      showSuccess(editingServicio ? 'Servicio actualizado correctamente' : 'Servicio creado correctamente');
      
    } catch (error) {
      console.error('Error al guardar:', error);
      dismissToast(toastId);
      showError(error.message || 'Error al guardar el servicio');
    }
  };

  const handleEdit = async (servicio) => {
    setEditingServicio(servicio);
    setTramos([]);
    
    const fechaSalida = servicio.fecha ? servicio.fecha.split('T')[0] : getTodayDate();
    const fechaLlegada = servicio.fechaLlegada ? servicio.fechaLlegada.split('T')[0] : fechaSalida;
    
    setFormData({
      origen: servicio.origen,
      destino: servicio.destino,
      fechaSalida: fechaSalida,
      horaSalida: servicio.horaSalida ? servicio.horaSalida.substring(0, 5) : '',
      fechaLlegada: fechaLlegada,
      horaLlegada: servicio.horaLlegada ? servicio.horaLlegada.substring(0, 5) : '',
      duracion: servicio.duracion || '',
      precio: servicio.precio || ''
    });
    await cargarMetodosAsignados(servicio.id);
    await cargarTramos(servicio.id);
    setShowModal(true);
  };

  // ✅ Consultar cantidad de reservas antes de mostrar el modal
  const handleDeleteClick = async (servicio) => {
    setServicioToDelete(servicio);
    setDeleteInfo({ reservasCount: 0, loading: true });
    setShowDeleteModal(true);
    
    try {
      const response = await fetch(`${API_URL}/admin/servicios/${servicio.id}/reservas-count`);
      if (response.ok) {
        const data = await response.json();
        setDeleteInfo({ reservasCount: data.count, loading: false });
      } else {
        setDeleteInfo({ reservasCount: 0, loading: false });
      }
    } catch (error) {
      console.error('Error al consultar reservas:', error);
      setDeleteInfo({ reservasCount: 0, loading: false });
    }
  };

  const handleConfirmDelete = async () => {
    if (servicioToDelete) {
      const toastId = showLoading('Eliminando servicio...');
      
      try {
        const response = await fetch(`${API_URL}/admin/servicios/${servicioToDelete.id}`, {
          method: 'DELETE'
        });
        
        if (!response.ok) {
          const errorText = await response.text();
          console.error('Error del backend:', errorText);
          throw new Error('Error al eliminar el servicio');
        }
        
        const result = await response.json();
        
        await cargarServicios();
        setShowDeleteModal(false);
        setServicioToDelete(null);
        setDeleteInfo({ reservasCount: 0, loading: false });
        dismissToast(toastId);
        
        if (result.reservasEliminadas > 0) {
          showSuccess(`Servicio eliminado junto con ${result.reservasEliminadas} reserva(s) asociada(s)`);
        } else {
          showSuccess('Servicio eliminado correctamente');
        }
      } catch (error) {
        console.error('Error al eliminar:', error);
        setShowDeleteModal(false);
        setServicioToDelete(null);
        setDeleteInfo({ reservasCount: 0, loading: false });
        dismissToast(toastId);
        showError('Error al eliminar el servicio');
      }
    }
  };

  // ============ ✅ PAUSAR / ACTIVAR SERVICIO ============

  const handleToggleActivoClick = (servicio) => {
    setServicioToToggle(servicio);
    setShowToggleModal(true);
  };

  const handleConfirmToggleActivo = async () => {
    if (!servicioToToggle) return;

    const toastId = showLoading(servicioToToggle.activo ? 'Pausando servicio...' : 'Activando servicio...');

    try {
      const response = await fetch(`${API_URL}/admin/servicios/${servicioToToggle.id}/toggle-activo`, {
        method: 'PATCH',
        headers: { 'Content-Type': 'application/json' }
      });

      if (!response.ok) throw new Error('Error al cambiar el estado');

      const data = await response.json();

      await cargarServicios();
      setShowToggleModal(false);
      setServicioToToggle(null);

      dismissToast(toastId);
      showSuccess(data.message || (data.activo ? 'Servicio activado' : 'Servicio pausado'));
    } catch (error) {
      console.error('Error:', error);
      dismissToast(toastId);
      showError('No se pudo cambiar el estado del servicio');
      setShowToggleModal(false);
      setServicioToToggle(null);
    }
  };

  // ============ MÉTODOS DE PAGO ============

  const handleOpenMetodos = async (servicio) => {
    setSelectedServicio(servicio);
    await cargarMetodosAsignados(servicio.id);
    setShowMetodosModal(true);
  };

  const handleGuardarMetodos = async () => {
    const toastId = showLoading('Asignando métodos...');
    
    try {
      const response = await fetch(`${API_URL}/admin/servicios/${selectedServicio.id}/metodos-pago`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(metodosSeleccionados)
      });

      if (!response.ok) throw new Error('Error al asignar métodos');

      setShowMetodosModal(false);
      setSelectedServicio(null);
      dismissToast(toastId);
      showSuccess('Métodos de pago asignados correctamente');
      
    } catch (error) {
      dismissToast(toastId);
      showError(error.message);
    }
  };

  const toggleMetodo = (metodoId) => {
    setMetodosSeleccionados(prev => 
      prev.includes(metodoId) 
        ? prev.filter(id => id !== metodoId)
        : [...prev, metodoId]
    );
  };

  // ============ TRAMOS CRUD ============

  const handleAddTramo = () => {
    if (!tramoForm.origen || !tramoForm.destino || !tramoForm.precio) {
      showError('Completá origen, destino y precio del tramo');
      return;
    }

    if (!tramoForm.fechaSalida || !tramoForm.horaSalida || !tramoForm.fechaLlegada || !tramoForm.horaLlegada) {
      showError('Completá fecha y hora de salida y llegada del tramo');
      return;
    }

    let duracion = tramoForm.duracion || '01:00:00';
    let horaSalida = tramoForm.horaSalida;
    let horaLlegada = tramoForm.horaLlegada;
    let fechaSalida = tramoForm.fechaSalida;
    let fechaLlegada = tramoForm.fechaLlegada;
    
    const newTramo = {
      id: Date.now(),
      origen: tramoForm.origen,
      destino: tramoForm.destino,
      precio: parseFloat(tramoForm.precio),
      duracion: duracion,
      fechaSalida: fechaSalida,
      fechaLlegada: fechaLlegada,
      horaSalida: horaSalida,
      horaLlegada: horaLlegada,
      activo: true
    };

    const nuevosTramos = [...tramos, newTramo];
    setTramos(nuevosTramos);
    setTramoForm({ origen: '', destino: '', precio: '', fechaSalida: '', horaSalida: '', fechaLlegada: '', horaLlegada: '', duracion: '' });
    showSuccess('Tramo agregado');
  };

  const handleEditTramo = (tramo) => {
    setEditingTramo(tramo);
    setTramoForm({
      origen: tramo.origen,
      destino: tramo.destino,
      precio: tramo.precio,
      fechaSalida: tramo.fechaSalida ? tramo.fechaSalida.split('T')[0] : '',
      horaSalida: tramo.horaSalida ? tramo.horaSalida.substring(0, 5) : '',
      fechaLlegada: tramo.fechaLlegada ? tramo.fechaLlegada.split('T')[0] : '',
      horaLlegada: tramo.horaLlegada ? tramo.horaLlegada.substring(0, 5) : '',
      duracion: tramo.duracion || ''
    });
  };

  const handleUpdateTramo = () => {
    if (!tramoForm.origen || !tramoForm.destino || !tramoForm.precio) {
      showError('Completá origen, destino y precio del tramo');
      return;
    }

    if (!tramoForm.fechaSalida || !tramoForm.horaSalida || !tramoForm.fechaLlegada || !tramoForm.horaLlegada) {
      showError('Completá fecha y hora de salida y llegada del tramo');
      return;
    }

    let duracion = tramoForm.duracion || '01:00:00';
    let horaSalida = tramoForm.horaSalida;
    let horaLlegada = tramoForm.horaLlegada;
    let fechaSalida = tramoForm.fechaSalida;
    let fechaLlegada = tramoForm.fechaLlegada;

    const updatedTramos = tramos.map(t => 
      t.id === editingTramo.id ? {
        ...t,
        origen: tramoForm.origen,
        destino: tramoForm.destino,
        precio: parseFloat(tramoForm.precio),
        duracion: duracion,
        fechaSalida: fechaSalida,
        fechaLlegada: fechaLlegada,
        horaSalida: horaSalida,
        horaLlegada: horaLlegada
      } : t
    );

    setTramos(updatedTramos);
    setEditingTramo(null);
    setTramoForm({ origen: '', destino: '', precio: '', fechaSalida: '', horaSalida: '', fechaLlegada: '', horaLlegada: '', duracion: '' });
    showSuccess('Tramo actualizado');
  };

  const handleDeleteTramo = (tramo) => {
    setTramoToDelete(tramo);
    setShowDeleteTramoModal(true);
  };

  const handleConfirmDeleteTramo = () => {
    if (tramoToDelete) {
      const updatedTramos = tramos.filter(t => t.id !== tramoToDelete.id);
      setTramos(updatedTramos);
      setTramoToDelete(null);
      setShowDeleteTramoModal(false);
      showSuccess('Tramo eliminado');
    }
  };

  const cancelEditTramo = () => {
    setEditingTramo(null);
    setTramoForm({ origen: '', destino: '', precio: '', fechaSalida: '', horaSalida: '', fechaLlegada: '', horaLlegada: '', duracion: '' });
  };

  // ============ UTILIDADES ============

  const resetForm = () => {
    setEditingServicio(null);
    setEditingTramo(null);
    setMetodosSeleccionados([]);
    setTramos([]);
    const today = getTodayDate();
    setFormData({
      origen: '', destino: '', fechaSalida: today, horaSalida: '',
      fechaLlegada: today, horaLlegada: '', duracion: '', precio: ''
    });
    setTramoForm({ origen: '', destino: '', precio: '', fechaSalida: '', horaSalida: '', fechaLlegada: '', horaLlegada: '', duracion: '' });
  };

  const formatPrecio = (precio) => {
    return new Intl.NumberFormat('es-AR').format(precio);
  };

  const formatDuracion = (duracion) => {
    if (!duracion) return '';
    if (typeof duracion === 'string') {
      const parts = duracion.split(':');
      if (parts.length === 3) {
        const horas = parseInt(parts[0]);
        const minutos = parseInt(parts[1]);
        if (horas >= 24) {
          const dias = Math.floor(horas / 24);
          const horasRestantes = horas % 24;
          if (dias > 0 && horasRestantes > 0 && minutos > 0) return `${dias}d ${horasRestantes}h ${minutos}m`;
          if (dias > 0 && horasRestantes > 0) return `${dias}d ${horasRestantes}h`;
          if (dias > 0) return `${dias}d`;
        }
        if (horas > 0 && minutos > 0) return `${horas}h ${minutos}m`;
        if (horas > 0) return `${horas}h`;
        if (minutos > 0) return `${minutos}m`;
      }
      if (parts.length === 2) {
        const horas = parseInt(parts[0]);
        const minutos = parseInt(parts[1]);
        if (horas >= 24) {
          const dias = Math.floor(horas / 24);
          const horasRestantes = horas % 24;
          if (dias > 0 && horasRestantes > 0) return `${dias}d ${horasRestantes}h`;
          if (dias > 0) return `${dias}d`;
        }
        if (horas > 0 && minutos > 0) return `${horas}h ${minutos}m`;
        if (horas > 0) return `${horas}h`;
        if (minutos > 0) return `${minutos}m`;
      }
    }
    return duracion;
  };

  const formatFecha = (fecha) => {
    if (!fecha) return 'Sin fecha';
    const dateStr = fecha.split('T')[0];
    const [year, month, day] = dateStr.split('-').map(Number);
    const fechaObj = new Date(Date.UTC(year, month - 1, day));
    const hoy = new Date();
    const manana = new Date();
    manana.setDate(hoy.getDate() + 1);
    
    const hoyStr = hoy.toISOString().split('T')[0];
    const mananaStr = manana.toISOString().split('T')[0];
    
    if (dateStr === hoyStr) return 'Hoy';
    if (dateStr === mananaStr) return 'Mañana';
    return fechaObj.toLocaleDateString('es-AR', {
      weekday: 'long',
      day: 'numeric',
      month: 'long',
      timeZone: 'UTC'
    });
  };

  const fechasConServicios = getFechasConServicios();
  const proximosDias = getProximosDias();
  
  const serviciosFiltrados = selectedFecha === 'todas' 
    ? servicios 
    : servicios.filter(s => s.fecha && s.fecha.split('T')[0] === selectedFecha);
  const serviciosPorFecha = serviciosFiltrados.reduce((acc, servicio) => {
    if (!servicio.fecha) return acc;
    const fechaKey = servicio.fecha.split('T')[0];
    if (!acc[fechaKey]) acc[fechaKey] = [];
    acc[fechaKey].push(servicio);
    return acc;
  }, {});
  const fechasOrdenadas = Object.keys(serviciosPorFecha).sort();

  const getDaysInMonth = (year, month) => {
    return new Date(year, month + 1, 0).getDate();
  };

  const calendarYear = calendarDate.getFullYear();
  const calendarMonth = calendarDate.getMonth();
  const daysInMonth = getDaysInMonth(calendarYear, calendarMonth);
  const firstDayOfMonth = new Date(calendarYear, calendarMonth, 1).getDay();

  const handleCalendarDateClick = (day) => {
    const yearStr = calendarYear;
    const monthStr = String(calendarMonth + 1).padStart(2, '0');
    const dayStr = String(day).padStart(2, '0');
    const fechaSeleccionada = `${yearStr}-${monthStr}-${dayStr}`;
    setSelectedFecha(fechaSeleccionada);
    setShowCalendar(false);
  };

  return (
    <AdminLayout>
      <div className="p-6">
        <div className="mb-6">
          <h1 className="text-2xl font-bold text-gray-800">Gestión de Servicios</h1>
          <p className="text-gray-500 text-sm">Administrá los viajes, horarios, precios y tramos</p>
        </div>

        {/* Filtro de fechas */}
        <div className="mb-6 bg-white rounded-xl shadow-sm border border-gray-200 p-4">
          <div className="flex items-center justify-between flex-wrap gap-4">
            <div className="flex items-center gap-3">
              <Calendar className="w-5 h-5 text-gray-600" />
              <span className="text-sm font-semibold text-gray-700">Filtrar por fecha</span>
            </div>
            
            <div className="relative" ref={calendarRef}>
              <button
                onClick={() => setShowCalendar(!showCalendar)}
                className="flex items-center gap-2 px-3 py-1.5 text-sm text-gray-600 border border-gray-300 rounded-lg hover:bg-gray-50 transition-colors"
              >
                <Calendar className="w-4 h-4" />
                {showCalendar ? 'Cerrar calendario' : 'Seleccionar fecha'}
                <ChevronRight className={`w-4 h-4 transition-transform ${showCalendar ? 'rotate-90' : ''}`} />
              </button>

              {showCalendar && (
                <div className="absolute top-full right-0 mt-2 z-20 bg-white rounded-xl shadow-lg border border-gray-200 p-4 w-80">
                  <div className="flex items-center justify-between mb-4">
                    <button
                      onClick={() => setCalendarDate(new Date(calendarYear, calendarMonth - 1, 1))}
                      className="p-1 hover:bg-gray-100 rounded-lg"
                    >
                      <ChevronLeft className="w-5 h-5" />
                    </button>
                    <span className="font-medium text-gray-800">
                      {calendarDate.toLocaleDateString('es-AR', { month: 'long', year: 'numeric' })}
                    </span>
                    <button
                      onClick={() => setCalendarDate(new Date(calendarYear, calendarMonth + 1, 1))}
                      className="p-1 hover:bg-gray-100 rounded-lg"
                    >
                      <ChevronRight className="w-5 h-5" />
                    </button>
                  </div>
                  
                  <div className="grid grid-cols-7 gap-1 text-center text-xs font-medium text-gray-500 mb-2">
                    {['Do', 'Lu', 'Ma', 'Mi', 'Ju', 'Vi', 'Sa'].map(day => (
                      <div key={day} className="py-1">{day}</div>
                    ))}
                  </div>
                  
                  <div className="grid grid-cols-7 gap-1">
                    {Array.from({ length: firstDayOfMonth }).map((_, i) => (
                      <div key={`empty-${i}`} className="h-9" />
                    ))}
                    {Array.from({ length: daysInMonth }).map((_, i) => {
                      const day = i + 1;
                      const dateStr = `${calendarYear}-${String(calendarMonth + 1).padStart(2, '0')}-${String(day).padStart(2, '0')}`;
                      const tieneServicios = fechasConServicios.has(dateStr);
                      const esSeleccionada = selectedFecha === dateStr;
                      
                      return (
                        <button
                          key={day}
                          onClick={() => handleCalendarDateClick(day)}
                          className={`
                            h-9 rounded-lg flex items-center justify-center text-sm transition-all
                            ${esSeleccionada ? 'bg-[#e83e8c] text-white' : 'hover:bg-gray-100'}
                            ${tieneServicios && !esSeleccionada ? 'bg-pink-50 text-pink-700 font-medium' : ''}
                          `}
                        >
                          {day}
                        </button>
                      );
                    })}
                  </div>
                </div>
              )}
            </div>
          </div>
          
          <div className="flex flex-wrap gap-2 mt-4">
            {proximosDias.map((dia) => (
              <button
                key={dia.fecha}
                onClick={() => setSelectedFecha(dia.fecha)}
                className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                  selectedFecha === dia.fecha
                    ? 'bg-[#e83e8c] text-white shadow-md'
                    : dia.tieneServicios
                      ? 'bg-pink-50 text-pink-700 hover:bg-pink-100 border border-pink-200'
                      : 'bg-gray-100 text-gray-500 hover:bg-gray-200'
                }`}
              >
                {dia.label}
                {dia.tieneServicios && selectedFecha !== dia.fecha && (
                  <span className="ml-1 w-1.5 h-1.5 bg-[#e83e8c] rounded-full inline-block"></span>
                )}
              </button>
            ))}
            
            <button
              onClick={() => setSelectedFecha('todas')}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-all ${
                selectedFecha === 'todas'
                  ? 'bg-[#e83e8c] text-white shadow-md'
                  : 'bg-gray-100 text-gray-600 hover:bg-gray-200'
              }`}
            >
              Todas las fechas
            </button>
          </div>
        </div>

        <div className="mb-6 flex justify-end gap-3">
          <button
            onClick={() => {
              resetForm();
              setShowModal(true);
            }}
            className="flex items-center gap-2 px-4 py-2 bg-[#e83e8c] hover:bg-[#c2185b] text-white rounded-lg transition-colors"
          >
            <Plus className="w-4 h-4" />
            Nuevo servicio
          </button>
        </div>

        {loading ? (
          <div className="text-center py-12 bg-white rounded-xl border border-gray-200">
            <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-[#e83e8c] mx-auto"></div>
            <p className="text-gray-500 mt-3">Cargando servicios...</p>
          </div>
        ) : fechasOrdenadas.length === 0 ? (
          <div className="text-center py-12 bg-white rounded-xl border border-gray-200">
            <Bus className="w-12 h-12 text-gray-300 mx-auto mb-3" />
            <p className="text-gray-500">No hay servicios para la fecha seleccionada</p>
          </div>
        ) : (
          <div className="space-y-6">
            {fechasOrdenadas.map((fecha) => (
              <div key={fecha} className="bg-white rounded-xl shadow-sm border border-gray-200 overflow-hidden">
                <div className="px-5 py-3 bg-gray-50 border-b border-gray-200">
                  <div className="flex items-center gap-2">
                    <Calendar className="w-4 h-4 text-gray-500" />
                    <span className="font-medium text-gray-700">
                      {formatFecha(fecha)}
                    </span>
                    <span className="text-xs text-gray-400 ml-2">
                      {serviciosPorFecha[fecha].length} servicios
                    </span>
                  </div>
                </div>
                <div className="divide-y divide-gray-100">
                  {serviciosPorFecha[fecha].map((servicio) => (
                    <div
                      key={servicio.id}
                      className={`p-4 hover:bg-gray-50 transition-colors ${!servicio.activo ? 'opacity-60' : ''}`}
                    >
                      <div className="flex items-center justify-between">
                        <div className="flex-1">
                          <div className="flex items-center gap-4 flex-wrap">
                            <div className="flex items-center gap-2">
                              <MapPin className="w-4 h-4 text-gray-400" />
                              <span className="font-medium text-gray-800">{servicio.origen}</span>
                              <span className="text-gray-400">→</span>
                              <span className="font-medium text-gray-800">{servicio.destino}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <Clock className="w-4 h-4 text-gray-400" />
                              <span className="text-sm text-gray-600">{servicio.horaSalida}</span>
                              <span className="text-gray-400">-</span>
                              <span className="text-sm text-gray-600">{servicio.horaLlegada}</span>
                            </div>
                            <div className="flex items-center gap-2">
                              <DollarSign className="w-4 h-4 text-gray-400" />
                              <span className="text-sm font-medium text-gray-800">
                                ${formatPrecio(servicio.precio)}
                              </span>
                            </div>
                            {servicio.tramos && servicio.tramos.length > 0 && (
                              <div className="flex items-center gap-1 px-2 py-1 bg-blue-50 rounded-full text-xs text-blue-700">
                                <GitBranch className="w-3 h-3" />
                                <span>{servicio.tramos.length} tramos</span>
                              </div>
                            )}
                            {/* ✅ Badge Pausado */}
                            {!servicio.activo && (
                              <div className="flex items-center gap-1 px-2 py-1 bg-orange-50 border border-orange-200 rounded-full text-xs text-orange-700 font-medium">
                                <Pause className="w-3 h-3" />
                                Pausado
                              </div>
                            )}
                          </div>
                        </div>
                        <div className="flex items-center gap-2">
                          {/* ✅ NUEVO: Botón pausar/activar */}
                          <button
                            onClick={() => handleToggleActivoClick(servicio)}
                            className={`p-2 rounded-lg transition-colors ${
                              servicio.activo
                                ? 'text-gray-400 hover:text-orange-500 hover:bg-orange-50'
                                : 'text-green-600 hover:text-green-700 hover:bg-green-50'
                            }`}
                            title={servicio.activo ? 'Pausar servicio' : 'Activar servicio'}
                          >
                            {servicio.activo ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
                          </button>
                          <button
                            onClick={() => handleOpenMetodos(servicio)}
                            className="p-2 text-gray-400 hover:text-[#e83e8c] hover:bg-pink-50 rounded-lg transition-colors"
                            title="Configurar métodos de pago"
                          >
                            <MoneyIcon className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleEdit(servicio)}
                            className="p-2 text-gray-400 hover:text-[#e83e8c] hover:bg-pink-50 rounded-lg transition-colors"
                          >
                            <Edit className="w-4 h-4" />
                          </button>
                          <button
                            onClick={() => handleDeleteClick(servicio)}
                            className="p-2 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded-lg transition-colors"
                          >
                            <Trash2 className="w-4 h-4" />
                          </button>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            ))}
          </div>
        )}
      </div>

      {/* ============ MODAL ÚNICO PARA CREAR/EDITAR SERVICIO + TRAMOS ============ */}
      {showModal && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-5 border-b border-gray-100 flex justify-between items-center sticky top-0 bg-white z-10">
              <h3 className="text-lg font-semibold text-gray-800">
                {editingServicio ? 'Editar servicio' : 'Nuevo servicio'}
              </h3>
              <button onClick={() => { setShowModal(false); resetForm(); }} className="p-1 text-gray-400 hover:text-gray-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <form onSubmit={handleSubmit} className="p-5 space-y-4">
              {/* ===== DATOS DEL SERVICIO ===== */}
              <div className="border-b border-gray-200 pb-4">
                <h4 className="text-xs font-semibold text-gray-600 uppercase tracking-wide mb-3">Datos del servicio</h4>
                
                <div className="grid grid-cols-2 gap-4">
                  <div className="relative">
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Origen</label>
                    <input 
                      type="text" 
                      value={formData.origen} 
                      onChange={handleOrigenChange}
                      onFocus={() => formData.origen && setShowOrigenSugerencias(true)}
                      onBlur={() => setTimeout(() => setShowOrigenSugerencias(false), 200)}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                      required 
                    />
                    {showOrigenSugerencias && origenSugerencias.length > 0 && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
                        {origenSugerencias.map((ciudad) => (
                          <div
                            key={ciudad.id}
                            onClick={() => seleccionarOrigen(ciudad)}
                            className="px-3 py-2 hover:bg-pink-50 cursor-pointer border-b border-gray-100 last:border-0"
                          >
                            <div className="text-sm font-medium text-gray-800">{ciudad.nombre}</div>
                            <div className="text-xs text-gray-500">{ciudad.estado}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>

                  <div className="relative">
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Destino</label>
                    <input 
                      type="text" 
                      value={formData.destino} 
                      onChange={handleDestinoChange}
                      onFocus={() => formData.destino && setShowDestinoSugerencias(true)}
                      onBlur={() => setTimeout(() => setShowDestinoSugerencias(false), 200)}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                      required 
                    />
                    {showDestinoSugerencias && destinoSugerencias.length > 0 && (
                      <div className="absolute z-10 w-full mt-1 bg-white border border-gray-200 rounded-lg shadow-lg max-h-60 overflow-auto">
                        {destinoSugerencias.map((ciudad) => (
                          <div
                            key={ciudad.id}
                            onClick={() => seleccionarDestino(ciudad)}
                            className="px-3 py-2 hover:bg-pink-50 cursor-pointer border-b border-gray-100 last:border-0"
                          >
                            <div className="text-sm font-medium text-gray-800">{ciudad.nombre}</div>
                            <div className="text-xs text-gray-500">{ciudad.estado}</div>
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mt-2">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Fecha salida</label>
                    <input 
                      type="date" 
                      value={formData.fechaSalida || getTodayDate()} 
                      onChange={(e) => setFormData({...formData, fechaSalida: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                      required 
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Hora salida</label>
                    <input 
                      type="time" 
                      value={formData.horaSalida || ''} 
                      onChange={(e) => setFormData({...formData, horaSalida: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                      required 
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4 mt-2">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Fecha llegada</label>
                    <input 
                      type="date" 
                      value={formData.fechaLlegada || getTodayDate()} 
                      onChange={(e) => setFormData({...formData, fechaLlegada: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                      required 
                    />
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Hora llegada</label>
                    <input 
                      type="time" 
                      value={formData.horaLlegada || ''} 
                      onChange={(e) => setFormData({...formData, horaLlegada: e.target.value})}
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                      required 
                    />
                  </div>
                </div>

                <div className="grid grid-cols-2 gap-4">
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Duración</label>
                    <input 
                      type="text" 
                      value={formData.duracion} 
                      readOnly
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm bg-gray-50" 
                    />
                    <p className="text-xs text-gray-400 mt-1">*Se calcula automáticamente</p>
                  </div>
                  <div>
                    <label className="block text-xs font-semibold text-gray-600 mb-1">Precio</label>
                    <input 
                      type="number" 
                      step="0.01"
                      value={formData.precio} 
                      onChange={(e) => setFormData({...formData, precio: e.target.value})} 
                      className="w-full px-3 py-2 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none" 
                      required 
                    />
                  </div>
                </div>
              </div>

              {/* ===== GESTIÓN DE TRAMOS ===== */}
              <div className="border-b border-gray-200 pb-4">
                <div className="flex items-center justify-between mb-3">
                  <h4 className="text-xs font-semibold text-gray-600 uppercase tracking-wide">Tramos</h4>
                  <span className="text-xs text-gray-400">{tramos.length} tramos</span>
                </div>

                <div className="bg-gray-50 p-3 rounded-lg border border-gray-200 mb-3">
                  <div className="grid grid-cols-2 gap-2">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Origen</label>
                      <select
                        value={tramoForm.origen}
                        onChange={(e) => setTramoForm({...tramoForm, origen: e.target.value})}
                        className="w-full px-2 py-1.5 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none"
                      >
                        <option value="">Seleccionar</option>
                        {ciudades.map(c => (
                          <option key={c.id} value={c.nombre}>{c.nombre}</option>
                        ))}
                      </select>
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Destino</label>
                      <select
                        value={tramoForm.destino}
                        onChange={(e) => setTramoForm({...tramoForm, destino: e.target.value})}
                        className="w-full px-2 py-1.5 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none"
                      >
                        <option value="">Seleccionar</option>
                        {ciudades
                          .filter(c => c.nombre !== tramoForm.origen)
                          .map(c => (
                            <option key={c.id} value={c.nombre}>{c.nombre}</option>
                          ))}
                      </select>
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-2 mt-2">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Fecha salida</label>
                      <input
                        type="date"
                        value={tramoForm.fechaSalida || ''}
                        onChange={(e) => setTramoForm({...tramoForm, fechaSalida: e.target.value})}
                        className="w-full px-2 py-1.5 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Hora salida</label>
                      <input
                        type="time"
                        value={tramoForm.horaSalida || ''}
                        onChange={(e) => setTramoForm({...tramoForm, horaSalida: e.target.value})}
                        className="w-full px-2 py-1.5 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-2 gap-2 mt-2">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Fecha llegada</label>
                      <input
                        type="date"
                        value={tramoForm.fechaLlegada || ''}
                        onChange={(e) => setTramoForm({...tramoForm, fechaLlegada: e.target.value})}
                        className="w-full px-2 py-1.5 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Hora llegada</label>
                      <input
                        type="time"
                        value={tramoForm.horaLlegada || ''}
                        onChange={(e) => setTramoForm({...tramoForm, horaLlegada: e.target.value})}
                        className="w-full px-2 py-1.5 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none"
                      />
                    </div>
                  </div>
                  
                  <div className="grid grid-cols-2 gap-2 mt-2">
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Duración</label>
                      <input
                        type="text"
                        value={tramoForm.duracion}
                        readOnly
                        className="w-full px-2 py-1.5 border border-gray-200 rounded-lg text-sm bg-gray-50"
                      />
                    </div>
                    <div>
                      <label className="block text-xs font-medium text-gray-600 mb-1">Precio</label>
                      <input
                        type="number"
                        step="0.01"
                        value={tramoForm.precio}
                        onChange={(e) => setTramoForm({...tramoForm, precio: e.target.value})}
                        placeholder="0.00"
                        className="w-full px-2 py-1.5 border border-gray-200 rounded-lg text-sm focus:border-[#e83e8c] focus:ring-2 focus:ring-[#e83e8c]/20 focus:outline-none"
                      />
                    </div>
                  </div>

                  <div className="flex gap-2 mt-2">
                    {editingTramo ? (
                      <>
                        <button
                          type="button"
                          onClick={handleUpdateTramo}
                          className="flex-1 py-1.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg text-sm font-medium transition-colors"
                        >
                          Actualizar tramo
                        </button>
                        <button
                          type="button"
                          onClick={cancelEditTramo}
                          className="px-3 py-1.5 border border-gray-300 rounded-lg text-sm text-gray-600 hover:bg-gray-50 transition-colors"
                        >
                          Cancelar
                        </button>
                      </>
                    ) : (
                      <button
                        type="button"
                        onClick={handleAddTramo}
                        className="w-full py-1.5 bg-[#e83e8c] hover:bg-[#c2185b] text-white rounded-lg text-sm font-medium transition-colors"
                      >
                        + Agregar tramo
                      </button>
                    )}
                  </div>
                </div>

                {tramos.length > 0 ? (
                  <div className="space-y-2 max-h-60 overflow-y-auto">
                    {tramos.map((tramo) => (
                      <div key={tramo.id} className="flex items-center justify-between p-2 bg-gray-50 rounded-lg border border-gray-200 hover:border-[#e83e8c] transition-colors">
                        <div className="flex items-center gap-2 flex-wrap">
                          <span className="text-sm font-medium text-gray-800">
                            {tramo.origen} → {tramo.destino}
                          </span>
                          <span className="text-sm text-[#e83e8c] font-bold">
                            ${formatPrecio(tramo.precio)}
                          </span>
                          <span className="text-xs text-gray-400">
                            {formatDuracion(tramo.duracion)}
                          </span>
                          {tramo.horaSalida && tramo.horaLlegada && tramo.fechaSalida && tramo.fechaLlegada && (
                            <span className="text-xs text-blue-600 font-medium">
                              🕐 {tramo.fechaSalida?.split('T')[0] || tramo.fechaSalida} {tramo.horaSalida.substring(0,5)} → {tramo.fechaLlegada?.split('T')[0] || tramo.fechaLlegada} {tramo.horaLlegada.substring(0,5)}
                            </span>
                          )}
                        </div>
                        <div className="flex items-center gap-1">
                          <button
                            type="button"
                            onClick={() => handleEditTramo(tramo)}
                            className="p-1 text-gray-400 hover:text-[#e83e8c] hover:bg-pink-50 rounded transition-colors"
                            title="Editar tramo"
                          >
                            <Pencil className="w-3.5 h-3.5" />
                          </button>
                          <button
                            type="button"
                            onClick={() => handleDeleteTramo(tramo)}
                            className="p-1 text-gray-400 hover:text-red-500 hover:bg-red-50 rounded transition-colors"
                            title="Eliminar tramo"
                          >
                            <Trash2 className="w-3.5 h-3.5" />
                          </button>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-400 text-center py-2">No hay tramos agregados</p>
                )}
              </div>

              {/* ===== MÉTODOS DE PAGO ===== */}
              <div>
                <label className="block text-xs font-semibold text-gray-600 mb-2">Métodos de pago disponibles</label>
                <div className="space-y-2 max-h-40 overflow-y-auto">
                  {metodosDisponibles.length === 0 ? (
                    <p className="text-sm text-gray-400">No hay métodos de pago configurados.</p>
                  ) : (
                    metodosDisponibles.map((metodo) => (
                      <label key={metodo.id} className="flex items-center gap-3 p-2 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                        <input
                          type="checkbox"
                          checked={metodosSeleccionados.includes(metodo.id)}
                          onChange={() => toggleMetodo(metodo.id)}
                          className="w-4 h-4 text-[#e83e8c] focus:ring-[#e83e8c] rounded"
                        />
                        <span className="text-sm text-gray-700">{metodo.nombre}</span>
                      </label>
                    ))
                  )}
                </div>
                <p className="text-xs text-gray-400 mt-2">Seleccioná los métodos de pago disponibles</p>
              </div>

              <div className="flex gap-3 pt-4 border-t border-gray-200">
                <button 
                  type="button" 
                  onClick={() => { setShowModal(false); resetForm(); }} 
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
                >
                  Cancelar
                </button>
                <button 
                  type="submit" 
                  className="flex-1 px-4 py-2 bg-[#e83e8c] hover:bg-[#c2185b] text-white rounded-lg flex items-center justify-center gap-2 transition-colors"
                >
                  <Check className="w-4 h-4" />
                  {editingServicio ? 'Guardar cambios' : 'Crear servicio'}
                </button>
              </div>
            </form>
          </div>
        </div>
      )}

      {/* ============ MODAL PARA ASIGNAR MÉTODOS DE PAGO ============ */}
      {showMetodosModal && selectedServicio && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full max-h-[90vh] overflow-y-auto">
            <div className="p-5 border-b border-gray-100 flex justify-between items-center sticky top-0 bg-white z-10">
              <h3 className="text-lg font-semibold text-gray-800">
                Métodos de pago - {selectedServicio.origen} → {selectedServicio.destino}
              </h3>
              <button onClick={() => setShowMetodosModal(false)} className="p-1 text-gray-400 hover:text-gray-600">
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-5 space-y-4">
              <p className="text-sm text-gray-500">Seleccioná los métodos de pago disponibles para este servicio</p>
              
              <div className="space-y-2">
                {metodosDisponibles.length === 0 ? (
                  <p className="text-sm text-gray-400 text-center py-4">
                    No hay métodos de pago configurados.
                  </p>
                ) : (
                  metodosDisponibles.map((metodo) => (
                    <label key={metodo.id} className="flex items-center gap-3 p-3 rounded-lg border border-gray-200 hover:bg-gray-50 cursor-pointer">
                      <input
                        type="checkbox"
                        checked={metodosSeleccionados.includes(metodo.id)}
                        onChange={() => toggleMetodo(metodo.id)}
                        className="w-4 h-4 text-[#e83e8c] focus:ring-[#e83e8c] rounded"
                      />
                      <span className="text-sm text-gray-700">{metodo.nombre}</span>
                    </label>
                  ))
                )}
              </div>

              <div className="flex gap-3 pt-4">
                <button 
                  type="button" 
                  onClick={() => setShowMetodosModal(false)} 
                  className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                >
                  Cancelar
                </button>
                <button 
                  onClick={handleGuardarMetodos}
                  className="flex-1 px-4 py-2 bg-[#e83e8c] hover:bg-[#c2185b] text-white rounded-lg flex items-center justify-center gap-2"
                >
                  <Check className="w-4 h-4" />
                  Guardar
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* ============ MODAL PERSONALIZADO DE CONFIRMACIÓN DE ELIMINACIÓN DE SERVICIO ============ */}
      {showDeleteModal && servicioToDelete && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full">
            <div className="p-5 border-b border-gray-100 flex justify-between items-center">
              <h3 className="text-lg font-semibold text-gray-800">Confirmar eliminación</h3>
              <button 
                onClick={() => { setShowDeleteModal(false); setServicioToDelete(null); setDeleteInfo({ reservasCount: 0, loading: false }); }} 
                className="p-1 text-gray-400 hover:text-gray-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>
            
            <div className="p-5 space-y-4">
              <div className="flex items-start gap-3">
                <div className="p-2 bg-red-100 rounded-lg flex-shrink-0">
                  <Trash2 className="w-5 h-5 text-red-600" />
                </div>
                <div className="flex-1">
                  <p className="text-sm text-gray-700">
                    ¿Estás seguro que deseas eliminar el servicio de{' '}
                    <strong>{servicioToDelete.origen}</strong> a <strong>{servicioToDelete.destino}</strong>?
                  </p>
                </div>
              </div>

              {deleteInfo.loading ? (
                <div className="bg-gray-50 border border-gray-200 rounded-lg p-4 flex items-center justify-center">
                  <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-[#e83e8c]"></div>
                  <span className="ml-3 text-sm text-gray-500">Consultando reservas asociadas...</span>
                </div>
              ) : deleteInfo.reservasCount > 0 ? (
                <div className="bg-red-50 border border-red-200 rounded-lg p-4">
                  <div className="flex items-start gap-3">
                    <AlertTriangle className="w-5 h-5 text-red-600 flex-shrink-0 mt-0.5" />
                    <div className="flex-1">
                      <p className="text-sm font-semibold text-red-800 mb-1">
                        ⚠️ Atención: este servicio tiene {deleteInfo.reservasCount} reserva(s) asociada(s)
                      </p>
                      <p className="text-xs text-red-700">
                        Si eliminás el servicio, también se eliminarán <strong>todas las reservas</strong> asociadas, 
                        incluyendo las que ya están pagadas. Esta acción no se puede deshacer.
                      </p>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                  <p className="text-xs text-green-700">
                    ✓ Este servicio no tiene reservas asociadas. Se puede eliminar sin problemas.
                  </p>
                </div>
              )}
            </div>

            <div className="p-5 border-t border-gray-100 flex gap-3">
              <button 
                type="button" 
                onClick={() => { setShowDeleteModal(false); setServicioToDelete(null); setDeleteInfo({ reservasCount: 0, loading: false }); }} 
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button 
                type="button" 
                onClick={handleConfirmDelete}
                disabled={deleteInfo.loading}
                className="flex-1 px-4 py-2 bg-red-600 hover:bg-red-700 text-white rounded-lg flex items-center justify-center gap-2 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
              >
                <Trash2 className="w-4 h-4" />
                Sí, eliminar
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ============ ✅ NUEVO: MODAL PAUSAR / ACTIVAR SERVICIO ============ */}
      {showToggleModal && servicioToToggle && (
        <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
          <div className="bg-white rounded-2xl shadow-xl max-w-md w-full">
            <div className="p-5 border-b border-gray-100 flex justify-between items-center">
              <h3 className="text-lg font-semibold text-gray-800">
                {servicioToToggle.activo ? 'Pausar servicio' : 'Activar servicio'}
              </h3>
              <button
                onClick={() => { setShowToggleModal(false); setServicioToToggle(null); }}
                className="p-1 text-gray-400 hover:text-gray-600"
              >
                <X className="w-5 h-5" />
              </button>
            </div>

            <div className="p-5 space-y-4">
              <div className="flex items-start gap-3">
                <div className={`p-2 rounded-lg flex-shrink-0 ${servicioToToggle.activo ? 'bg-orange-100' : 'bg-green-100'}`}>
                  {servicioToToggle.activo
                    ? <Pause className="w-5 h-5 text-orange-600" />
                    : <Play className="w-5 h-5 text-green-600" />}
                </div>
                <div className="flex-1">
                  <p className="text-sm text-gray-700">
                    ¿{servicioToToggle.activo ? 'Pausar' : 'Activar'} el servicio de{' '}
                    <strong>{servicioToToggle.origen}</strong> a <strong>{servicioToToggle.destino}</strong>?
                  </p>
                </div>
              </div>

              {servicioToToggle.activo ? (
                <div className="bg-orange-50 border border-orange-200 rounded-lg p-3">
                  <p className="text-xs text-orange-800">
                    ⏸️ El servicio <strong>no aparecerá</strong> en el listado público ni se podrá vender.
                    Las reservas existentes se mantienen intactas y podés reactivarlo cuando quieras.
                  </p>
                </div>
              ) : (
                <div className="bg-green-50 border border-green-200 rounded-lg p-3">
                  <p className="text-xs text-green-800">
                    ▶️ El servicio volverá a aparecer en el listado público y podrá venderse nuevamente.
                  </p>
                </div>
              )}
            </div>

            <div className="p-5 border-t border-gray-100 flex gap-3">
              <button
                type="button"
                onClick={() => { setShowToggleModal(false); setServicioToToggle(null); }}
                className="flex-1 px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 transition-colors"
              >
                Cancelar
              </button>
              <button
                type="button"
                onClick={handleConfirmToggleActivo}
                className={`flex-1 px-4 py-2 text-white rounded-lg flex items-center justify-center gap-2 transition-colors ${
                  servicioToToggle.activo
                    ? 'bg-orange-500 hover:bg-orange-600'
                    : 'bg-green-600 hover:bg-green-700'
                }`}
              >
                {servicioToToggle.activo ? <Pause className="w-4 h-4" /> : <Play className="w-4 h-4" />}
                {servicioToToggle.activo ? 'Sí, pausar' : 'Sí, activar'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* ============ MODAL DE CONFIRMACIÓN DE ELIMINACIÓN DE TRAMO ============ */}
      <ModalConfirm
        isOpen={showDeleteTramoModal}
        onClose={() => setShowDeleteTramoModal(false)}
        onConfirm={handleConfirmDeleteTramo}
        title="Confirmar eliminación"
        message={`¿Estás seguro que deseas eliminar el tramo "${tramoToDelete?.origen} → ${tramoToDelete?.destino}"?`}
        confirmText="Sí, eliminar"
        cancelText="Cancelar"
        confirmButtonColor="#dc2626"
      />
    </AdminLayout>
  );
};

export default ServiciosAdmin;